module.exports = __webpack_public_path__ + "img/banner_left.af7b44e5.png";